(function () {
  'use strict';

  /* ── DOM refs ────────────────────────────────────── */

  var overlay  = document.getElementById('bs-cart-overlay');
  var panel    = document.getElementById('bs-cart-panel');
  var template = document.getElementById('bs-cart-item-template');
  if (!overlay || !panel) return;

  /* ── Constants ───────────────────────────────────── */

  var thresholdCents = parseInt(overlay.dataset.freeShippingThreshold, 10) || 4000;
  var stickerMov     = parseInt(overlay.dataset.stickerMov, 10) || 2500;

  /* ── Sticker variant ID (hardcoded — product not accessible via storefront JSON) ── */

  var STICKER_ID = 53115640512779;

  var body       = panel.querySelector('[data-bs-cart-body]');
  var subtotalEl = panel.querySelector('[data-bs-cart-subtotal]');
  var checkoutEl = panel.querySelector('[data-bs-checkout]');
  var textEl     = panel.querySelector('[data-bs-progress-text]');
  var reminderEl = panel.querySelector('[data-bs-sticker-reminder]');
  var movNotice  = panel.querySelector('[data-bs-mov-notice]');

  /* ── State ───────────────────────────────────────── */

  var lastCartTotal = 0;

  /* ── Helpers ─────────────────────────────────────── */

  function formatPrice(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function updateHeaderBadge(count) {
    var badge = document.querySelector('[data-bs-cart-badge]');
    if (!badge) return;
    badge.textContent = count < 100 ? count : '99';
    if (count > 0) {
      badge.classList.remove('is-hidden');
    } else {
      badge.classList.add('is-hidden');
    }
  }

  function isStickerInCart(cart) {
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].variant_id === STICKER_ID) return true;
    }
    return false;
  }

  function getStickerItem(cart) {
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].variant_id === STICKER_ID) return cart.items[i];
    }
    return null;
  }

  function nonPackSubtotal(cart) {
    var total = 0;
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].variant_id !== STICKER_ID) {
        total += cart.items[i].final_line_price;
      }
    }
    return total;
  }

  /* ── Progress bar ────────────────────────────────── */

  function updateProgress(subtotalCents) {
    var segments = panel.querySelectorAll('.bs-progress-bar__seg');
    if (!segments.length) return;
    var total  = segments.length;
    var filled = Math.min(Math.ceil((subtotalCents / thresholdCents) * total), total);
    segments.forEach(function (seg, i) {
      seg.classList.toggle('filled', i < filled);
    });

    if (textEl) {
      if (subtotalCents >= thresholdCents) {
        textEl.textContent = "YOU'VE UNLOCKED FREE SHIPPING";
        textEl.style.color = '#4CAF50';
      } else {
        textEl.textContent = "YOU'RE " + formatPrice(thresholdCents - subtotalCents) + ' AWAY FROM FREE SHIPPING';
        textEl.style.color = '';
      }
    }
  }

  /* ── Sticker Game: badge, banner, checkout guard ─── */

  function updateStickerGame(cart) {
    var claimed = isStickerInCart(cart);

    /* Dispatch state event so PDP badge can react */
    document.dispatchEvent(new CustomEvent('bs:sticker-state', { detail: { claimed: claimed } }));

    /* Reminder banner: show when MOV met and pack not yet in cart */
    if (reminderEl) {
      var nonPack = nonPackSubtotal(cart);
      var shouldShow = !claimed && nonPack >= stickerMov;
      if (shouldShow) {
        reminderEl.removeAttribute('hidden');
      } else {
        reminderEl.setAttribute('hidden', '');
      }
    }

    /* MOV guard: disable checkout when ONLY the free pack is in cart */
    if (movNotice && checkoutEl) {
      var onlyPack = cart.item_count > 0 &&
        cart.items.every(function (item) { return item.variant_id === STICKER_ID; });

      if (onlyPack) {
        movNotice.removeAttribute('hidden');
        checkoutEl.setAttribute('aria-disabled', 'true');
        checkoutEl.style.pointerEvents = 'none';
        checkoutEl.style.opacity = '0.4';
      } else {
        movNotice.setAttribute('hidden', '');
        checkoutEl.removeAttribute('aria-disabled');
        checkoutEl.style.pointerEvents = '';
        checkoutEl.style.opacity = '';
      }
    }
  }

  /* ── Reminder banner "CLAIM" — delegated on panel ── */

  panel.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-bs-reminder-claim]');
    if (!btn || btn.disabled) return;
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: STICKER_ID, quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status && data.status >= 400) {
          console.error('[bs-cart] reminder claim error:', data);
          return;
        }
        return fetchCart();
      })
      .then(function (cart) { if (cart) render(cart); })
      .catch(function (err) {
        console.error('[bs-cart] reminder claim failed', err);
      })
      .finally(function () {
        btn.disabled = false;
      });
  });

  /* ── Item rendering ──────────────────────────────── */

  function buildItem(item) {
    var isPack = item.variant_id === STICKER_ID;
    var clone  = template.content.cloneNode(true);
    var art    = clone.querySelector('.bs-cart-item');
    var img    = clone.querySelector('.bs-cart-item__image');
    var title  = clone.querySelector('.bs-cart-item__title');
    var qty    = clone.querySelector('.bs-cart-item__quantity');
    var variant = clone.querySelector('.bs-cart-item__variant');
    var price  = clone.querySelector('.bs-cart-item__price');
    var remove = clone.querySelector('.bs-cart-item__remove');

    if (isPack) {
      art.classList.add('bs-cart-item--pack');

      if (item.featured_image && item.featured_image.url) {
        img.src = item.featured_image.url;
        img.alt = item.title;
      } else {
        img.remove();
      }

      title.textContent = 'Sticker Pack';
      if (qty) qty.remove();
      if (variant) variant.remove();

      price.textContent = 'Free';
      price.classList.add('bs-cart-item__price--free');

      remove.dataset.itemKey = item.key;
      remove.setAttribute('aria-label', 'Remove Sticker Pack');
    } else {
      if (item.featured_image && item.featured_image.url) {
        img.src = item.featured_image.url;
        img.alt = item.title;
      } else {
        img.remove();
      }

      title.textContent = item.product_title || item.title;
      if (qty) qty.textContent = 'Quantity: ' + item.quantity;

      if (item.variant_title && item.variant_title !== 'Default Title') {
        if (variant) variant.textContent = 'SIZE: ' + item.variant_title;
      } else {
        if (variant) variant.remove();
      }

      price.textContent = formatPrice(item.final_line_price);
      remove.dataset.itemKey = item.key;
      remove.setAttribute('aria-label', 'Remove ' + item.title);
    }

    var wrap = document.createElement('div');
    wrap.appendChild(clone);
    return wrap.innerHTML;
  }

  /* ── Footer update ───────────────────────────────── */

  function updateFooter(cart) {
    if (subtotalEl) subtotalEl.textContent = formatPrice(cart.total_price);
    updateHeaderBadge(cart.item_count);
  }

  /* ── Full render ─────────────────────────────────── */

  function render(cart) {
    lastCartTotal = cart.total_price;
    updateProgress(nonPackSubtotal(cart));
    updateStickerGame(cart);

    if (cart.item_count === 0) {
      body.innerHTML = '<p class="bs-cart-drawer__empty">Your cart is empty.</p>';
    } else {
      body.innerHTML = cart.items.map(buildItem).join('');

      body.querySelectorAll('.bs-cart-item__remove').forEach(function (btn) {
        btn.addEventListener('click', function () {
          removeItem(btn.dataset.itemKey);
        });
      });
    }

    updateFooter(cart);
  }

  /* ── Remove item ─────────────────────────────────── */

  function removeItem(key) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { render(cart); })
      .catch(function (err) { console.error('[bs-cart] remove failed', err); });
  }

  /* ── Fetch cart ──────────────────────────────────── */

  function fetchCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); });
  }

  /* ── Open / Close ────────────────────────────────── */

  function openDrawer() {
    updateProgress(lastCartTotal);

    panel.style.transform = 'translateX(100%)';
    overlay.removeAttribute('hidden');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        panel.style.transform = 'translateX(0)';
      });
    });
  }

  function closeDrawer() {
    panel.style.transform = 'translateX(100%)';
    setTimeout(function () {
      overlay.setAttribute('hidden', '');
      overlay.setAttribute('aria-hidden', 'true');
      panel.style.transform = '';
      document.body.style.overflow = '';
    }, 300);
  }

  /* ── Overlay click closes, panel click stops propagation ── */

  overlay.addEventListener('click', closeDrawer);
  panel.addEventListener('click', function (e) { e.stopPropagation(); });

  /* ── Tooltip ─────────────────────────────────────── */

  var infoBtn = panel.querySelector('.bs-cart-progress__info-btn');
  var tooltip = panel.querySelector('.bs-cart-progress__tooltip');

  if (infoBtn && tooltip) {
    infoBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      if (tooltip.hasAttribute('hidden')) {
        tooltip.removeAttribute('hidden');
      } else {
        tooltip.setAttribute('hidden', '');
      }
    });

    panel.addEventListener('click', function () {
      if (!tooltip.hasAttribute('hidden')) {
        tooltip.setAttribute('hidden', '');
      }
    });
  }

  /* ── Close triggers ──────────────────────────────── */

  panel.querySelectorAll('[data-bs-cart-close]').forEach(function (el) {
    el.addEventListener('click', closeDrawer);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !overlay.hasAttribute('hidden')) closeDrawer();
  });

  /* ── Cart-icon click ─────────────────────────────── */

  document.querySelectorAll('[data-bs-cart-trigger]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      if (!overlay.hasAttribute('hidden')) { closeDrawer(); return; }
      fetchCart()
        .then(function (cart) {
          render(cart);
          openDrawer();
        })
        .catch(function (err) { console.error('[bs-cart] fetch failed', err); });
    });
  });

  /* ── Dawn pubsub — add-to-cart ───────────────────── */

  if (typeof subscribe === 'function') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (payload) {
      if (!payload || payload.source !== 'product-form') return;

      fetchCart()
        .then(function (cart) {
          render(cart);
          openDrawer();
        })
        .catch(function (err) { console.error('[bs-cart] post-add fetch failed', err); });
    });
  }

  /* ── Expose global API for sticker modals ────────── */

  window.BSCart = {
    render: render,
    fetchAndRender: function () {
      return fetchCart().then(function (cart) { render(cart); return cart; });
    }
  };
  window.BSCart.refreshCartState = window.BSCart.fetchAndRender;

  /* ── Global banner handler — called via inline onclick ── */

  window.refreshCartDrawer = function () {
    var dawnBanner = document.getElementById('bs-dawn-sticker-reminder');
    if (dawnBanner) dawnBanner.setAttribute('hidden', '');
    fetchCart().then(function (cart) {
      render(cart);
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items' });
      }
    });
  };

  window.bsClaimStickerBanner = function (e) {
    e.stopPropagation();
    var banner = document.getElementById('bs-dawn-sticker-reminder');
    if (!banner) return;
    if (banner.dataset.processing === 'true') return;
    banner.dataset.processing = 'true';
    console.log('[banner] onclick fired directly');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items: [{ id: STICKER_ID, quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        console.log('[banner] add success:', data);
        if (window.refreshCartDrawer) window.refreshCartDrawer();
      })
      .catch(function (err) {
        console.error('[banner] add error:', err);
      })
      .finally(function () {
        banner.dataset.processing = 'false';
      });
  };

})();
